module.exports = __webpack_public_path__ + "static/media/Roboto-Thin.f09d9b5e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Thin.woff
// module id = 550
// module chunks = 0